import React from 'react'

import logo from '@assets/form/logo le ficaneur-03.svg'

import './ConnectionCard.css'

interface ConnectionCardProps {
	children: React.ReactNode
}

// ConnectionCard is the shared chrome of the signed-out pages (connection,
// password reset): navy backdrop with the oversized wordmark, silver card and
// logo. Pages only provide the form inside it.
function ConnectionCard(props: ConnectionCardProps) {
	return (
		<div className='connectionPage'>
			<div className='connectionBackdrop' />
			<div className='connectionCard'>
				<h1 className='connectionLogo'>
					<img src={logo} alt='Le Ficaneur' />
				</h1>
				{props.children}
			</div>
		</div>
	)
}

export default ConnectionCard
